define('shared/lib/deepmerge',['node_modules/deepmerge/dist/umd'], function(deepmerge){
    return deepmerge;
});
